import React, { CSSProperties, useState } from 'react';
import Lightbox from 'react-image-lightbox';

export interface IProps {
  className?: string;
  alt?: string;
  src?: string;
  title?: string;
  style?: CSSProperties;
  onClick?: () => void;
  lightboxImages?: (string | undefined)[];
}

export default function BaseImage(props: IProps) {
  const { className, alt, src, title, style, onClick, lightboxImages } = props;
  const [isOpenLightBox, setIsOpenLightBox] = useState<boolean>(false);
  const [lightBoxImageIndex, setLightBoxImageIndex] = useState<number>(0);
  const tempLightboxImages: string[] = lightboxImages
    ? (lightboxImages.filter(Boolean) as string[])
    : [];
  const isUseLightBox = tempLightboxImages && tempLightboxImages.length;

  const img = (
    <img
      className={className}
      alt={alt}
      src={src}
      title={title}
      style={{
        objectFit: 'contain',
        ...style,
      }}
      onClick={() => {
        if (onClick) {
          onClick();
        } else if (isUseLightBox) {
          setIsOpenLightBox(true);
        }
      }}
    />
  );

  if (!onClick && isUseLightBox && lightboxImages) {
    return (
      <>
        {img}
        {isOpenLightBox && (
          <Lightbox
            mainSrc={tempLightboxImages[lightBoxImageIndex]}
            prevSrc={tempLightboxImages[lightBoxImageIndex - 1]}
            nextSrc={tempLightboxImages[lightBoxImageIndex + 1]}
            onCloseRequest={() => setIsOpenLightBox(false)}
            reactModalStyle={{
              overlay: {
                zIndex: 2000,
              },
            }}
            imagePadding={50}
            onMovePrevRequest={() =>
              setLightBoxImageIndex(lightBoxImageIndex - 1)
            }
            onMoveNextRequest={() =>
              setLightBoxImageIndex(lightBoxImageIndex + 1)
            }
            imageTitle={title}
          />
        )}
      </>
    );
  }

  return img;
}
